export const PERFORMANCE_ENUM = {
  NOT_INFORMED: 0,

  ON_TIME: 1,
  LATE_RISK: 2,
  LATED: 3,

  ON_TIME_WITH_JUSTIFICATION: 4,
  LATE_RISK_WITH_JUSTIFICATION: 5,
  LATED_WITH_JUSTIFICATION: 6,
  LATE_WITHOUT_JUSTIFICATION: 7,

  CANCELED: 8,
};

export const PERFORMANCE_ENUM_TRANSKEY = {
  [PERFORMANCE_ENUM.NOT_INFORMED]: 'Não informado',

  [PERFORMANCE_ENUM.ON_TIME]: 'No prazo',
  [PERFORMANCE_ENUM.LATE_RISK]: 'Risco de atraso',
  [PERFORMANCE_ENUM.LATED]: 'Atrasado',

  [PERFORMANCE_ENUM.ON_TIME_WITH_JUSTIFICATION]: 'No prazo',
  [PERFORMANCE_ENUM.LATE_RISK_WITH_JUSTIFICATION]: 'Risco de atraso',
  [PERFORMANCE_ENUM.LATED_WITH_JUSTIFICATION]: 'Atraso justificado',
  [PERFORMANCE_ENUM.LATE_WITHOUT_JUSTIFICATION]: 'Atrasado',

  [PERFORMANCE_ENUM.CANCELED]: 'Cancelado',
};

export const PERFORMANCE_COLORS = {
  [PERFORMANCE_ENUM.NOT_INFORMED]: '#CCCCCC',

  [PERFORMANCE_ENUM.ON_TIME]: '#4CAF50',
  [PERFORMANCE_ENUM.LATE_RISK]: '#FF9800',
  [PERFORMANCE_ENUM.LATED]: '#F44336',

  [PERFORMANCE_ENUM.ON_TIME_WITH_JUSTIFICATION]: '#4CAF50',
  [PERFORMANCE_ENUM.LATE_RISK_WITH_JUSTIFICATION]: '#FF9800',
  [PERFORMANCE_ENUM.LATED_WITH_JUSTIFICATION]: '#4CAF50',
  [PERFORMANCE_ENUM.LATE_WITHOUT_JUSTIFICATION]: '#F44336',

  [PERFORMANCE_ENUM.CANCELED]: '#757575',
};

export const SCHEDULED = {
  TRUE: true,
  FALSE: false,
};

export const returnScheduledTranskey = scheduled => (scheduled ? 'Entrega agendada' : 'Entrega não agendada');

export const returnScheduledColor = scheduled => (scheduled ? '#229DEC' : 'rgba(0, 0, 0, 0.22)');
